<div class="container-fluid">
	<div class="col-md-12" *ngIf="isLoading">
		<app-busy [message]="message"></app-busy>
	</div>
	<div class="page_header">
		<h1 class="heading">Manage {{this.lblHeading}}</h1>
	</div>

	<ng-template #content let-modal>
		<div class="modal-header">
			<h4 class="modal-title" id="modal-basic-title"> Delete Confirmation</h4>
			<button type="button" class="btn-close" aria-label="Close"
				(click)="modal.dismiss('Cross click')">&times;</button>
		</div>
		<div class="modal-body">
			<input type="hidden" [(ngModel)]="removeRef" name="id" /> <span [innerHTML]="deleteConfirm"></span>
		</div>
		<div class="modal-footer">
			<button class="btn btn-danger btn-sm" (click)="onDelete(removeRef.id)" style="width:80px;">Yes</button>
			<button class="btn btn-default btn-sm" (click)="modal.dismiss('Cross click')"
				style="width:80px;">No</button>
		</div>
	</ng-template>

	<div class="row">
		<div *ngIf="isRemove" class="text-danger col-md-12">
			<input type="hidden" [(ngModel)]="removeRef" name="id" /> <span [innerHTML]="deleteConfirm"></span>
			<button class="btn btn-danger btn-sm" (click)="onDelete(removeRef.id)" style="width:80px;">Yes</button>
			<button class="btn btn-default btn-sm" (click)="onNo()" style="width:80px;">No</button>
		</div>
		<div class="col-md-12" *ngIf="!isRemove">
			<app-actions [actions]="vehicleActions" (actionEvent)="doVehicleAction($event)"></app-actions>
			<div class="table-responsive">
				<table id="vTypes" class="table table-sm custom_table">
					<thead class="thead-inverse">
						<tr class="hd-clpse">
							<th>Select</th>
							<th class="bfr-end-col">
								Code <i style="vertical-align:middle; " class="fa fa-sort"
									[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"
									(click)="utility.onSort(1)"></i>
							</th>
							<th class="bfr-end-col">
								Description
								<i style="vertical-align:middle;" class="fa"
									[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagDN == 2),'fa-sort-desc sort-d': (utility.flags.flagDN == 3), 'fa-sort':(utility.flags.flagDN == 1) }"
									(click)="utility.onSort(2)"></i>
							</th>
							<th class="bfr-end-col">Passengers
							</th>
							<th class="bfr-end-col">
								Active?
								<i style="vertical-align:middle;" class="fa"
									[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagAE == 2),'fa-sort-desc sort-d': (utility.flags.flagAE == 3), 'fa-sort':(utility.flags.flagAE == 1) }"
									(click)="utility.onSort(3)"></i>
							</th>
							<th class="bfr-end-col">
								Sort Order
								<i style="vertical-align:middle;" class="fa"
									[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagSO == 2),'fa-sort-desc sort-d': (utility.flags.flagSO == 3), 'fa-sort':(utility.flags.flagSO == 1) }"
									(click)="utility.onSort(5)"></i>
							</th>
							<th class="bfr-end-col">
								Group
								<i style="vertical-align:middle;" class="fa"
									[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagGC == 2),'fa-sort-desc sort-d': (utility.flags.flagGC == 3), 'fa-sort':(utility.flags.flagGC == 1) }"
									(click)="utility.onSort(4)"></i>
							</th>
							<th class="bfr-end-col">Display</th>
							<!-- <th class="btn-show hgt-btn bfr-end-col end-col" style="width:110px !important;padding:1px 0;">
				  <a [routerLink]="['/vehicle/type/add']" title="" style="" class="">
					<span title="Add a New Vehicle Type" class=" btn-add btn btn-primary btn-sm"><i class="fa fa-plus fa-2x" aria-hidden="true"></i></span>
				  </a>
				</th> -->
						</tr>
					</thead>
					<tr style="height: 10px !important;"
						*ngFor="let vType of vTypes  | orderBy: utility.criteria : utility.direction | paginate: { itemsPerPage: showNum, currentPage: utility.page }">
						<td><input type="checkbox" value="{{item}}" (change)="CheckedVehicle($event,pType)"></td>
						<td class="bfr-end-col">{{vType.code}}</td>
						<td class="bfr-end-col">{{vType.description}}</td>
						<td class="bfr-end-col">{{vType.passengers}}</td>
						<td class="bfr-end-col">{{utility.isActive(vType.is_active)}}</td>
						<td class="bfr-end-col ">{{vType.sort_order}}</td>
						<td class="bfr-end-col">{{vType.group_code}}</td>
						<td class="bfr-end-col">{{utility.showDisplayIndicator(vType.display_ind)}}</td>
						<!-- <td class="btn-show bfr-end-col end-col" style="width:110px !important;padding:4px 0;">
				<a [routerLink]="['/vehicle/type/edit',vType.id]"><span title="Edit Vehicle Type" style="margin-right: 10px; color:#00236F;"><i class="fa fa-pencil fa-fw"></i></span></a>
				<span title="Delete Vehicle Type" style="margin-right: 10px; color:#00236F;" (click)="onConfirm(vType)"><i class="fa fa-trash-o fa-fw"></i></span>
			  </td> -->
					</tr>
					<tfoot>
						<tr *ngIf="vTypes.length > 4" class="pagination_row">
							<td colspan="8" class="rm-brd" >
								<div class="row">
									<div class="col-sm-6">
										<div class="input-group mb-3 rm-brd"
											style="width:125px!important;height:30px!important;">
											<div class="input-group-prepend">
												<label class="input-group-text form-control-sm show-h" for="show-id"
													>Show:</label>
											</div>
											<select class="form-control form-control-sm show-h" id="show-id"
												[(ngModel)]="showNum">
												<option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}
												</option>
											</select>
										</div>
									</div>
									<div class="col-sm-6 text-right">
										<pagination-controls (pageChange)="utility.page = $event"></pagination-controls>
									</div>
								</div>
							</td>
						</tr>
						<tr *ngIf="isEmpty">
							<td colspan="4" class="rm-brd">
								<span class="text-info text-small">No vehicle types found.</span>
							</td>
						</tr>
					</tfoot>
				</table>
			</div>
		</div>
	</div>
</div>